// Module
var code = "<div vngage-security-warning ng-if=\"vm.coBrowserSecurity.check\"></div> <div id=\"react-queue\"></div> <div data-ng-controller=\"DesktopLegacy as desktopLegacy\" id=\"desktopLegacy\" class=\"desktopLegacy\"></div>";
// Exports
var _module_exports =code;;
var path = 'app/desktop.OLD/DesktopTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;